export class CalculateUser {
  userID: string;
  organisationID: string[];

  constructor(userID: string, organisationID: string[]) {
    this.userID = userID;
    this.organisationID = organisationID;
  }
}
